var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FFF3C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7061 20V20.0561V25.6645C63.0165 27.1788 71.7376 38.3676 70.2233 50.678C68.9334 60.8853 60.9134 68.9895 50.7061 70.1953V75.8037C66.1292 74.2614 77.346 60.5769 75.8037 45.1537C74.5418 31.8338 63.9699 21.318 50.7061 20ZM45.0976 20.0841C39.6294 20.6169 34.4136 22.7201 30.1512 26.2534L34.1612 30.4036C37.302 27.8798 41.0876 26.2534 45.0976 25.6925V20.0841ZM26.1973 30.2073C22.664 34.4697 20.5608 39.6575 20 45.1537H25.6084C26.1412 41.1718 27.7116 37.3861 30.2073 34.2173L26.1973 30.2073ZM57.7166 38.1432L44.032 51.8277L38.0871 45.8828L35.1147 48.8553L44.032 57.7727L60.689 41.1157L57.7166 38.1432ZM20.028 50.7621C20.5889 56.2584 22.7481 61.4462 26.2253 65.7086L30.2073 61.6985C27.7396 58.5298 26.1412 54.7441 25.6365 50.7621H20.028ZM34.1612 65.8207L30.1512 69.6625C34.3856 73.1958 39.6014 75.4111 45.0976 76V70.3916C41.1157 69.8868 37.33 68.2884 34.1612 65.8207Z",
    fill: "#E48900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconLarge);
export default __webpack_public_path__ + "static/media/PendingIconLarge.1890ece5bd78fd5a8406f8a595889ca1.svg";
export { ForwardRef as ReactComponent };